import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCommencementNotificationByFolderId } from "../../Thunks/BuildingInspectorThunks";
import { CommencementNotification } from "../../Types/CommencementNotification/CommencementNotificationTypes";

interface CommencementNotificationSliceState {
    loader: boolean; // for refres pages and inital loadings
    commencementNotification: CommencementNotification|null;
    errorDisplay: string | null;
}

// set inital valus
const initialState : CommencementNotificationSliceState = {
    loader: false,
    commencementNotification: null,
    errorDisplay: '',

}

// set state valu for api response
const commencementNotificationSlice = createSlice ({
    name: 'commencementNotificationSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getCommencementNotificationByFolderId.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getCommencementNotificationByFolderId.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getCommencementNotificationByFolderId.fulfilled, (state, action: PayloadAction<CommencementNotification>) => {
                    state.loader = false;
                    state.commencementNotification = action.payload;
                  })
    }
})

export const {} = commencementNotificationSlice.actions
export default commencementNotificationSlice.reducer
